import { render, staticRenderFns } from "./SelectAuthorizationFlow.vue?vue&type=template&id=495e8742&scoped=true&"
import script from "./SelectAuthorizationFlow.vue?vue&type=script&lang=ts&"
export * from "./SelectAuthorizationFlow.vue?vue&type=script&lang=ts&"
import style0 from "./SelectAuthorizationFlow.vue?vue&type=style&index=0&id=495e8742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495e8742",
  null
  
)

export default component.exports